// src/hooks/useFormatMessage.js
import { useIntl } from 'react-intl';

const useFormatMessage = () => {
    const intl = useIntl();

    const t = (messageKey) => {
        if (messageKey === null || messageKey === undefined || messageKey === "") {
            return "";
        }
        return intl.formatMessage({ id: messageKey, defaultMessage: messageKey });
    };

    return { t };
};

export default useFormatMessage;
